// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe-wrapper iframe[data-v-4c966314]{height:1120px;margin:auto}@media(min-width:768px){.iframe-wrapper iframe[data-v-4c966314]{height:850px}}", ""]);
// Exports
module.exports = exports;
